// extracted by css-extract-rspack-plugin
export default {"select":"select-dCaO6V","turnPageButton":"turnPageButton-KL4aXo"};